import { useLanguage } from "../../components/LanguageProvider/LanguageProvider";
import DashboardLayout from "../../components/Layout/DashboardLayout";
import DashboardCard from "../../components/common/DashboardCard";

const Dashboard = () => {
  const { language, setLanguage } = useLanguage(); // false for English, true for Hindi
  return (
    <DashboardLayout
      pageTitle={language ? "डैशबोर्ड" : "Dashboard"}
      mainClass="p-6"
    >
      <div className="bg-white p-6 rounded shadow-md  mx-auto">
        <DashboardCard />
      </div>
    </DashboardLayout>
  );
};

export default Dashboard;
